<template>
    <div v-if="category">
        <div class="text-center pt-4 pb-4">
            <h3 class="category-header">{{ category.category_name }}</h3>
            <p v-if="category.category_desc" v-html="category.category_desc"></p>
            <p v-else>{{ category.product_count_total }} {{ __('redeem.products') }}</p>
        </div>
        <div v-if="product_list.length" class="row">
            <div v-for="(product, p_index) in product_list" :key="p_index" class="col-xxl-2 col-md-3 col-sm-6 col-6 mb-5">
                <product-box
                    :product="product"
                    :order="order"
                    :points="points"
                    :type="category.type"
                    :testmode="testmode"
                ></product-box>
            </div>
        </div>
        <div class="text-center pb-4" v-if="(max_products>0 && category.product_count_total > max_products) || category.type!=='products'">
            <div v-if="category.type==='products'" class="pb-4">
                <button class="btn btn-primary btn-alla btn-lg mb-2" @click="max_products=0">
                    {{ __('redeem.entire_supply') }} {{ category.category_name }}
                </button>
                <p style="font-style:italic; font-size: 13px; color: #666;">{{ __('redeem.entire_supply_more_prefix') }}
                    {{ category.product_count_total - max_products }} {{ __('redeem.entire_supply_more_suffix') }}</p>
            </div>
            <div v-else-if="showMediaButton()" class="pb-4">
                <a :href="'/'+__('redeem.current_langcode')+'/redeem/media/'+category.prod_id" class="btn btn-primary btn-alla btn-lg">
                    {{ __('redeem.entire_supply') }} {{ category.category_name }}
                </a>
            </div>
            <div v-else-if="category.type==='sfanytime_codes'" class="pb-4">
                <form :action="'/'+__('redeem.current_langcode')+'/redeem/update'" method="POST">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="item_id" :value="category.prod_id">
                    <button type="submit" class="btn btn-primary btn-alla btn-lg">
                        <span v-if="category.btn_text">{{ category.btn_text }}</span>
                        <span v-else>{{ __('redeem.choose') }} {{ category.category_name }}</span>
                    </button>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        category: {
            type: Object,
            default() {
                return {};
            },
        },
        points: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Boolean,
            default: false,
        },
        pointsLeft: {
            type: Number,
            default: 0,
        },
        testmode: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        max_products: 18,
    }),
    computed: {
        product_list() {
            if (this.max_products > 0) {
                return this.category.products.slice(0, this.max_products);
            }
            return this.category.products;
        },
    },
    methods: {
        isRedeemed() {
            return !!this.order;
        },
        showMediaButton() {
            const { category } = this;
            return category.type === 'pocket_pack'
                || category.type === 'magazine_subscription';
        },
    },
};
</script>
